module.exports = __webpack_public_path__ + "img/logo-text-light.8c9c083e.svg";